
import React from 'react';

interface TeacherOfflineIndicatorProps {
  resource: 'list' | 'details' | 'form';
  teacherId?: string;
}

export const TeacherOfflineIndicator: React.FC<TeacherOfflineIndicatorProps> = () => {
  // This component now returns null, effectively hiding any offline indicators in the teacher section
  return null;
};
